import React from 'react';

export default function Admin(){
    return(
        <>
            _o.0_
        </>
    );
}